import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/16x16/info.svg';
import { ReactComponent as PlusIcon } from '@elementary/common-ui/assets/20x20/plus-black.svg';
import { Button, Flex, FlexColumn } from '@elementary/common-ui/components';
import { capitalize } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { fontSize, fontWeight } from '@elementary/common-ui/style/utils';

type Props = {
  onClick: () => void;
  mode?: 'set' | 'add';
};

const AddAlertDestinationButton = ({ onClick, mode = 'set' }: Props) => (
  <FlexColumn sx={{ gap: 2 }}>
    <Button
      variant="outlined"
      sx={{ width: 'fit-content' }}
      startIcon={<PlusIcon />}
      onClick={onClick}
    >
      {capitalize(mode)} custom alert destination
    </Button>
    <Flex sx={{ gap: 1 }}>
      <Flex>
        <InfoIcon />
      </Flex>
      <Typography
        sx={{ fontSize: fontSize('sm'), fontWeight: fontWeight('medium') }}
      >
        Please note that selecting custom destinations
        <Typography
          component="span"
          sx={{
            fontSize: fontSize('sm'),
            fontWeight: fontWeight('semibold'),
            mr: 0.5,
            ml: 0.5,
          }}
        >
          will override
        </Typography>
        all existing and future matching alert rules for this test.
      </Typography>
    </Flex>
  </FlexColumn>
);

export default AddAlertDestinationButton;
